/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Import the SVG as a URL for background image
import backgroundSvgUrl from './abstract_background.svg';

import s from './styles.module.scss';

const LayoutShared = ({ className = null, children = null, header = null, footer = null }) => (
  <div className={cx(s.layout, className)}>
    {header && <div className={s.layoutHeader}>{header}</div>}
    <div className={s.layoutBackground} style={{ backgroundImage: `url(${backgroundSvgUrl})` }} />
    <div className={s.layoutContent}>{children}</div>
    {footer && <div className={s.layoutFooter}>{footer}</div>}
  </div>
);

LayoutShared.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.node,
};

export default LayoutShared;
